import { render } from "./Pacientes.vue?vue&type=template&id=06893aeb&scoped=true"
import script from "./Pacientes.vue?vue&type=script&lang=js"
export * from "./Pacientes.vue?vue&type=script&lang=js"

import "./Pacientes.vue?vue&type=style&index=0&id=06893aeb&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06893aeb"]])

export default __exports__